module.exports = __webpack_public_path__ + "img/Pelletsorten.84daf96.webp";